import apiClient from './client';

/**
 * Best-effort email notifications for evaluation workflow.
 * These are fire-and-forget: they do NOT block the caller's flow.
 * Each function returns { ok: true } on success or { ok: false, reason: string } on failure.
 * The caller decides whether to show a toast or silently ignore the failure.
 *
 * @module notifications
 */

/**
 * Notify leader when levantador submits evaluation for review.
 * @returns {Promise<{ok: boolean, reason?: string}>}
 */
export async function notifySubmitted({ leaderEmail, leaderName, senderName, evaluationName, version, projectName, semaforo, score, maxScore, percentage }) {
  try {
    // #M10 — el backend (extended_routes.py notify_evaluation_submitted)
    // exige leader_email (400 "leader_email requerido" con el nombre
    // viejo) y lee levantador_name/project_name, no recipient_email/
    // sender_name/evaluation_name — el request siempre fallaba.
    await apiClient.post('/notify/evaluation-submitted', {
      leader_email: leaderEmail,
      leader_name: leaderName,
      levantador_name: senderName,
      evaluation_name: evaluationName,
      version,
      project_name: projectName,
      semaforo,
      score,
      max_score: maxScore,
      percentage,
    });
    return { ok: true };
  } catch (err) {
    return { ok: false, reason: err?.response?.data?.detail || err?.message || 'Error de red' };
  }
}

/**
 * Notify levantador when leader returns evaluation.
 * @returns {Promise<{ok: boolean, reason?: string}>}
 */
export async function notifyReturned({ levantadorEmail, levantadorName, senderName, evaluationName, version, comments }) {
  try {
    // #M10 — el backend exige levantador_email (400 con el nombre viejo)
    // y lee leader_name, no recipient_email/sender_name.
    await apiClient.post('/notify/evaluation-returned', {
      levantador_email: levantadorEmail,
      levantador_name: levantadorName,
      leader_name: senderName,
      evaluation_name: evaluationName,
      version,
      comments,
    });
    return { ok: true };
  } catch (err) {
    return { ok: false, reason: err?.response?.data?.detail || err?.message || 'Error de red' };
  }
}

/**
 * Notify levantador when leader publishes evaluation.
 * @returns {Promise<{ok: boolean, reason?: string}>}
 */
export async function notifyPublished({ levantadorEmail, levantadorName, senderName, evaluationName, version, semaforo, score, maxScore, percentage }) {
  try {
    // #M10 — el backend lee levantador_email (no recipient_email); sin
    // ese campo, sent:false y ningún correo se envía.
    await apiClient.post('/notify/evaluation-published', {
      levantador_email: levantadorEmail,
      levantador_name: levantadorName,
      sender_name: senderName,
      evaluation_name: evaluationName,
      version,
      semaforo,
      score,
      max_score: maxScore,
      percentage,
    });
    return { ok: true };
  } catch (err) {
    return { ok: false, reason: err?.response?.data?.detail || err?.message || 'Error de red' };
  }
}
